module.exports = {
  src: __webpack_public_path__ + "assets/images/phone_sms_photo.758c7b518b1a3605.png",
  width: 393,
  height: 235,
  toString: function() { return __webpack_public_path__ + "assets/images/phone_sms_photo.758c7b518b1a3605.png"; }
};